/**
 * 课程内容
 * @description 课程内容
 * @author yly
 * @date 2023-9-12
 *  */
import React from 'react';
import { connect } from 'dva';
import { Spin, Divider, Form } from 'antd'
import { AuditForm } from './components'
import { framework_tool, component_tool } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer } = framework_tool;
let { WizButton, WizModal, WizIcon, WizDropdown, WizMenu, WizTable, } = component_tool;
const WizItem = WizMenu.Item

class WizCourseUpdateContent extends WizContainer {

  componentName = 'WizCourseUpdateContent';

  constructor(props) {
    super(props);
    this.state = {
      stateSelects: props.initSelects || [],
      data: {},
      rowData: new Date().getTime(),
      programContent: [],
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
      addType: '',
    }
  }

  static defaultProps = {
    onChange: () => { },//点击modal 确定的回调方法
    value: [],//已选数据,
    modalProps: {},//modal的参数
    selectProps: {},//输入框的参数
    wizTreeSelectListProps: {},//WizTreeSelectList的参数
    apiProps: {},//调用分类接口的参数
    apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
    returnKey: false,//onChange返回数据是否需要key，默认返回对象
  };



  _outListOver(nextProps, nextState) {
    if (nextProps.outList?.length > 0) {
      let arr = []
      nextProps.outList.forEach((item, index) => {
        let { orderNum, type, title, entityId, code } = item
        arr.push({ orderNum, contentType: type, originalName: title, originalId: entityId, originalCode: code, dataChange: 0 })
      })
      nextState.programContent = arr
    }
    return true;
  }

  _editOver(nextProps, nextState) {
    if (nextProps.editList?.length > 0) {
      let copy = JSON.parse(JSON.stringify(nextProps.editList))
      copy.forEach(item => {
        item.fileId = [{ fileId: item.fileId }]
      })
      nextState.programContent = copy
    }
    return true;
  }

  _resetNumOver(nextProps, nextState) {
    const { onChange } = nextProps
    if (nextProps.resetNum) {
      if (nextProps.editList?.length > 0) {
        nextState.programContent = nextProps.editList
        onChange && onChange(nextProps.editList)
      }
      if (nextProps.outList?.length > 0) {
        let arr = []
        nextProps.outList.forEach((item, index) => {
          let { orderNum, type, title, entityId, code } = item
          arr.push({ orderNum, contentType: type, originalName: title, originalId: entityId, originalCode: code, dataChange: 0 })
        })
        nextState.programContent = arr
        onChange && onChange(arr)
      }
    }
    return true;
  }

  /**
   * 初始化时根据record判断是新增还是编辑
   */
  _componentDidMount() {

  }

  propsAndStateOnChange = {
    outList: this._outListOver.bind(this),
    editList: this._editOver.bind(this),
    resetNum: this._resetNumOver.bind(this),
  }


  handleMenuClick(e) {
    let { programContent } = this.state
    let data = {}
    data.orderNum = programContent ? programContent.length + 1 : 1
    data.contentType = e.key === 'programAdd' ? 0 : 1
    data.fileType = 0
    this.setState({ scheduleModalVisible: true, data: data, addType: 'add' })
  }
  // formatList = (content) => {
  //   content.forEach(item => {
  //     item.fileId = item.fileId[0]?.fileId
  //   })
  //   return content
  // }
  rankList = (list) => {
    let copyList = JSON.parse(JSON.stringify(list))
    let filterNumArr = []
    let primaryRank = []
    copyList.forEach((item, index) => {
      if (item.changeType == 2) {
        filterNumArr.push(index)
      }
      primaryRank.push({ ...item, orderNum: index + 1 })
    })
    primaryRank.forEach((item, index) => {
      filterNumArr.forEach(fItem => {
        if (index == fItem) {
          item.orderNum = ''
        } else if (index > fItem) {
          item.orderNum = item.orderNum - 1
        }
      })
    })
    return primaryRank
  }
  submit = (data) => {
    let { onChange } = this.props
    console.log('提交  =====>', data)
    let content = [...this.state.programContent]
    let { addType } = this.state
    let arr = []
    if (addType == 'add') {
      data.changeType = 3
      data.dataChange = 1
      arr = content.concat(data)
    } else {
      content.forEach(item => {
        if (item.orderNum == data.orderNum) {
          arr.push({ ...item, dataChange: 1, changeType: 1, name: data.name, fileName: data.fileName, fileId: data.fileId, fileType: data.fileType, address: data.address })
        } else {
          arr.push(item)
        }
      })
    }
    let finalArr = this.rankList(arr)
    this.setState({ programContent: this.rankList(arr), scheduleModalVisible: false })
    // let copyArr=this.formatList([...arr])
    onChange && onChange(finalArr)
  }
  cancel = () => {
    this.setState({ scheduleModalVisible: false })
  }
  /**选择课件模态框 */
  scheduleListModal() {

    const { data, addType } = this.state

    return (
      <WizModal
        visible={this.state.scheduleModalVisible}
        onCancel={() => this.setState({ scheduleModalVisible: false })}
        footer={null}
        style={{ minWidth: 1000 }}
        title={`${!data.isRead ? addType == 'add' ? '新增' : '编辑' : '查看'}课程内容-${data.contentType == 0 ? '课件' : '考试'}`}
        key={this.state.scheduleListModalKey}
      >
        <AuditForm data={data} submit={this.submit} cancel={this.cancel} />
      </WizModal>
    )
  }

  editRecord = (record, type) => {
    record.isRead = false
    if (type == 1) {
      record.fileType = 0
      record.name = ''
      record.fileId = ''
    }
    this.setState({ data: record, scheduleModalVisible: true, addType: 'edit' })
  }

  deleteRow = (record, index) => {
    WizModal.confirm({
      title: "您正在做移除操作，是否确认？",
      onOk: () => {
        let { onChange } = this.props
        let content = [...this.state.programContent]
        let arr = []
        content.forEach((item, i) => {
          if (i == index) {
            arr.push({ ...item, changeType: 2, dataChange: 1 })
          } else {
            arr.push(item)
          }
        })
        let finalArr = this.rankList(arr)
        this.setState({ programContent: finalArr })
        onChange && onChange(finalArr)
      },
      onCancel() {
      },
    });

  }
  cancelUpdate = (record, index) => {
    WizModal.confirm({
      title: "您是否确认取消更新？",
      onOk: () => {
        let { onChange } = this.props
        let content = JSON.parse(JSON.stringify(this.state.programContent))
        let arr = []
        if (record.changeType == 3) {
          arr = content.filter((x, i) => i != index)
        } else {
          content.forEach((item, i) => {
            if (i == index) {
              arr.push({ ...item, dataChange: 0, changeType: '', name: '', address: '', fileId: '' })
            } else {
              arr.push(item)
            }
          })
        }
        let finalArr = this.rankList(arr)
        this.setState({ programContent: finalArr })
        onChange && onChange(finalArr)
      },
      onCancel() {
      },
    });

  }
  lookRecord = (record) => {
    record.isRead = true
    this.setState({ data: record, scheduleModalVisible: true })
  }
  /**上移下移 行数据 */
  moveUpAndDown(record) {
    let { onChange } = this.props

    const programContent = [...this.state.programContent];

    const indexOf = programContent?.indexOf(record);
    // 是否上移
    const hasMoveUp = indexOf > 0

    console.log('moveUpAndDown --->', programContent, record, indexOf, hasMoveUp)
    if (!programContent?.length || (hasMoveUp && indexOf <= 0) || (!hasMoveUp && indexOf === programContent.length - 1)) {
      console.log('操作失败,请检查数据.可能原因无数据、已经到顶了、已经到底了')
      return;
    }
    // 数据位置替换
    programContent.splice(indexOf, 1)
    if (hasMoveUp) {
      programContent.splice(indexOf - 1, 0, record)
    } else {
      programContent.splice(indexOf + 1, 0, record)
    }
    // 重新计算排列顺序
    const neoProgramContent = programContent.map(({ orderNum, ...item }, index) => ({ ...item, orderNum: index + 1 }))
    // 保存变更到state
    let rankNeoProgramContent = this.rankList(neoProgramContent)
    this.setState({
      programContent: rankNeoProgramContent,
      time: new Date().getTime()
    })
    onChange && onChange(rankNeoProgramContent)

  }
  _render() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key="programAdd">
          课件
        </WizItem>
        <WizItem key="examAdd">
          考试
        </WizItem>
      </WizMenu>
    );
    const columns = [

      {
        title: '排序',
        dataIndex: 'orderNum',
        key: 'orderNum',
        width: 60
      },
      {
        title: '类型',
        dataIndex: 'contentType',
        key: 'contentType',
        width: 60,
        render: (text) => text == 0 ? '课件' : '考试'
      },
      {
        title: '内容原名称',
        dataIndex: 'originalName',
        key: 'originalName',
        width: 120,
        ellipsis: true,
      },
      {
        title: '课件编码',
        dataIndex: 'originalCode',
        key: 'originalCode',
        width: 100,
      },
      {
        title: '是否更新',
        dataIndex: 'dataChange ',
        key: 'dataChange ',
        width: 100,
        render: (text, record) => {
          return (
            <>
              {record.dataChange == '1' ? '是' : '否'}
            </>
          )

        }
      },
      {
        title: '更新类型',
        dataIndex: 'changeType',
        key: 'changeType',
        width: 100,
        render: (text) => text == 2 ? '内容移除' : (text == 1 ? '内容更新' : (text == 3 ? '内容新增' : ''))
      },
      {
        title: '内容新名称',
        dataIndex: 'name',
        key: 'name',
        width: 120,
        ellipsis: true,
      },
      {
        title: '更新后内容',
        dataIndex: 'fileId',
        key: 'fileId',
        width: 120,
        ellipsis: true,
        render: (text, record) => {
          return (<>
            {(record?.fileId?.length > 0 && record.fileId[0]?.fileId) || record.address ? <a onClick={() => this.lookRecord(record)}>查看</a> : null}
          </>
          )
        }
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record, index) => (
          <span>
            {!record.name && record.changeType != 2 ?
              <>
                <a onClick={e => this.editRecord(record, 1)}> 更新</a>
              </>
              : <>
                {record.changeType != 2 ? <a onClick={e => this.editRecord(record)}> 编辑</a> : null}
                <a onClick={e => this.cancelUpdate(record, index)}> 取消更新</a>
              </>
            }
            {record.changeType != 2 && record.changeType != 3 ? <a onClick={e => this.deleteRow(record, index)}> 移除</a> : null}

            {record.changeType != 2 ?
              <>
                <Divider type="vertical" />
                <a onClick={e => this.moveUpAndDown(record)}> {record.orderNum == 1 ? '下' : '上'}移</a>
                <Divider type="vertical" />
              </>
              : null}
          </span>
        ),
      },
    ];
    return (
      <>
        <>
          课程内容：
          <WizDropdown overlay={menu}>
            <WizButton type="primary">
              新增课程内容 <WizIcon type="down" />
            </WizButton>
          </WizDropdown>
        </>
        <div className="table-row" key={'program_content_' + this.state.time}>
          <WizTable pagination={false} columns={columns} dataSource={this.state.programContent} />
        </div>
        {this.scheduleListModal()}
      </>)
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionType } = state;
  const { apiProps } = ownProps;

  const treeData = modelUtils.getModelEntity(questionType, `questionType@treeData${apiProps && apiProps.type || ''}`);
  const load = modelUtils.getLoadingState(state, "selects");

  return {
    treeData,
    ...load
  }
};

const options = { withRef: true };
export default Form.create()(connect(mapStateToProps, null, null, options)(WizCourseUpdateContent));

